import React from 'react';
import AssistantAvatar from '../AssistantAvatar';
import classes from './TypingLoader.module.scss';

const TypingLoader = () => (
  <div className={classes.Container}>
    <AssistantAvatar />
    <div className={classes.MessageWrapper}>
      <div className={classes.Bubble}>
        <div className={classes.Dots}>
          <span className={classes.Dot + ' ' + classes.DotFirst} />
          <span className={classes.Dot + ' ' + classes.DotSecond} />
          <span className={classes.Dot + ' ' + classes.DotThird} />
        </div>
      </div>
    </div>
  </div>
);

export default TypingLoader;
